import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Skeleton } from "@/components/ui/skeleton";

interface GroupNotificationsProps {
  groupId: string;
  isAdmin: boolean;
}

export const GroupNotifications = ({ groupId, isAdmin }: GroupNotificationsProps) => {
  const { data: notifications, isLoading } = useQuery({
    queryKey: ['group-notifications', groupId],
    queryFn: async () => {
      // Temporarily return empty array to fix type issue
      return [];
    },
  });

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-16 w-full" />
        <Skeleton className="h-16 w-full" />
      </div>
    );
  }

  if (!notifications?.length) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No notifications for this group
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {notifications.map((notification) => (
        <div 
          key={notification.id}
          className="p-4 rounded-lg border bg-card text-card-foreground shadow-sm"
        >
          <p>{notification.content}</p>
          <p className="text-sm text-muted-foreground mt-2">
            {new Date(notification.created_at).toLocaleDateString()}
          </p>
        </div>
      ))}
    </div>
  );
};